import type { CustomFieldDefinition } from 'modules/requests/hooks/useCreateCustomItem';

export type GuidedCustomStepCommand =
  | 'fillLabel'
  | 'fillInstructions'
  | 'attachSamplePdf'
  | 'save'
  | 'openCreatedStep';

export type GuidedCustomStepCommandSignal = {
  signalId: number;
  command: GuidedCustomStepCommand;
  success?: boolean;
};

export const GUIDED_CUSTOM_STEP_LABEL = 'Pay the attached invoice';

export const GUIDED_CUSTOM_STEP_PAYMENT_URL =
  'https://example.com/liscio-demo-payment';

export const GUIDED_CUSTOM_STEP_TEXT =
  'Please review the attached invoice and use this link to make your payment:\n\n' +
  `${GUIDED_CUSTOM_STEP_PAYMENT_URL}\n\n` +
  '(This link is for demo purposes only and does not process a real payment.)\n\n' +
  'After payment, return to this delivery and mark this step complete so we know you are ready for us to finalize the delivery.';

export const GUIDED_CUSTOM_STEP_TEXT_HTML =
  '<p>Please review the attached invoice and use this link to make your payment:</p>' +
  `<p><a href="${GUIDED_CUSTOM_STEP_PAYMENT_URL}" target="_blank" rel="noopener noreferrer">${GUIDED_CUSTOM_STEP_PAYMENT_URL}</a></p>` +
  '<p>(This link is for demo purposes only and does not process a real payment.)</p>' +
  '<p>After payment, return to this delivery and mark this step complete so we know you are ready for us to finalize the delivery.</p>';

export const GUIDED_CUSTOM_STEP_SAMPLE_FILE_NAME =
  'sample-custom-step-payment-instructions.pdf';

export const GUIDED_CUSTOM_STEP_SAMPLE_FILE_HREF =
  `/tax-delivery-guided-demo/${GUIDED_CUSTOM_STEP_SAMPLE_FILE_NAME}`;

export const createGuidedCustomStepInitialFields = (): CustomFieldDefinition[] => [
  {
    id: 'guided_custom_step_payment_invoice',
    label: '',
    description: '',
    fieldType: 'file',
    required: false,
    textContent: '',
    firmFiles: [],
  },
];
